module.exports = __webpack_public_path__ + "media/images/article/ballon_tail-07a2e09ef60832d588d53116eea142bf.png";